import React from "react";
import { navigate, Redirect, useParams } from "helpers/tixxt-router";
import ChannelPage from "components/channels/ChannelPage";
import { useWidget } from "components/channels/api";
import "./widgets.css";
import PageLoading from "components/shared/PageLoading";
import ImagesGalleryPage from "components/shared/ImagesGalleryPage";
import { useQueryParams } from "helpers/useQueryParams";

export default function ShowWidgetPage() {
  const { channelSlug, widgetId } = useParams();
  const { lng } = useQueryParams() as { lng?: string };
  const { data, isLoading } = useWidget({
    channelSlug,
    widgetId,
    params: {
      lng,
    },
  });

  if (isLoading) {
    return <PageLoading />;
  }

  switch (data?.type) {
    case "images": {
      const images = data.images;
      return (
        <>
          <ChannelPage />
          {images && (
            <ImagesGalleryPage
              {...data}
              images={images}
              onClose={() =>
                navigate(
                  `/channels/${channelSlug}${lng ? `?lng=${lng}` : ""}`,
                  { replace: true },
                )
              }
            />
          )}
        </>
      );
    }
    default:
      // redirect to channel page for all widgets other than images, which should show gallery in overlay
      return window.Settings?.development ? (
        <div className={"alert alert-info prose"}>
          TODO Implement case for <code>{data?.type}</code> in ShowWidgetPage /
          WidgetPageByType
        </div>
      ) : (
        <Redirect to={`/channels/${channelSlug}`} />
      );
  }
}
